// extracted by mini-css-extract-plugin
export default {"tab":"VBTab_tab__GJXkG","active":"VBTab_active__l+jEH","linkStyle":"VBTab_linkStyle__k6ivI"};